import FloatingButton from './floatingButton';

export * from './floatingButton';

export default FloatingButton;
